import {
  put,
  fork,
  call,
  takeLatest,
  all,
} from 'redux-saga/effects';
import app from '../../app';
import {
  readPopupContentCompletion,
  readPayNoticeContentCompletion,
} from '../../actions';

export function* watchReadPopupContent() {
  yield takeLatest('READ_POPUP_CONTENT', function*({ popupId }) {
    const options = {
      url: `/sfapi/popup/stop/${popupId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(readPopupContentCompletion(result.error, result.data));
  });
}

export function* watchReadPayNoticeContent() {
  yield takeLatest('READ_PAY_NOTICE_CONTENT', function*({ popupId }) {
    const options = {
      url: `/sfapi/popup/stop/${popupId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(readPayNoticeContentCompletion(result.error, result.data));
  });
}

export default function* popupSaga() {
  yield all([
    fork(watchReadPopupContent),
    fork(watchReadPayNoticeContent),
  ]);
}
